import { API, graphqlOperation } from "aws-amplify"
import {
	getListGlobalProject,
	getListMyProject,
	getOtherProject,
	getProject,
	queryProject,
	getReport,
	getReportglobalproject,
	getProjecthistory,
	getRecommendProject,
	getProjectOverview
} from "../graphql/queries"
import {
	createProject,
	updateProject,
	deleteProject,
	addLikeProject,
	unLikeProject,
	addToMyProject
} from "../graphql/mutation"
import {
	GET_LIST_GLOBAL_PROJECT,
	GET_LIST_MY_PROJECT,
	GET_PROJECT,
	GET_PROJECT_HISTORY,
	CREATE_PROJECT,
	UPDATE_PROJECT,
	DELETE_PROJECT,
	CLEAR_PROJECT,
	CLEAR_LIST_GLOBAL_PROJECT,
	CLEAR_LIST_MY_PROJECT,
	QUERY_GLOBAL_PROJECT,
	QUERY_MY_PROJECT,
	GET_OTHER_PROJECT,
	CLEAR_OTHER_PROJECT,
	PUT_REPORTFILE,
	GET_REPORTFILE,
	DELETE_REPORTFILE,
	ADD_AMOUNT_COMMENT,
	REDUCE_AMOUNT_COMMENT,
	LIKE_PROJECT,
	UNLIKE_PROJECT,
	CLEAR_REPORTFILE,
	ADD_TO_MY_PROJECT,
	GET_PROJECT_NOTI,
	GET_RECOMMEND_PROJECT
} from "../ActionTypes"
import { putReport, deleteReport } from "../FunctionAction/function.project"

export const getlistglobalproject = (ExclusiveStartKey, ordering) => ({
	type: GET_LIST_GLOBAL_PROJECT,
	payload: API.graphql(
		graphqlOperation(getListGlobalProject(ExclusiveStartKey, ordering))
	)
})

export const getlistmyproject = (ExclusiveStartKey, ordering, user_id) => ({
	type: GET_LIST_MY_PROJECT,
	payload: API.graphql(
		graphqlOperation(getListMyProject(ExclusiveStartKey, ordering, user_id))
	)
})

export const getotherproject = (user_id, ExclusiveStartKey) => ({
	type: GET_OTHER_PROJECT,
	payload: API.graphql(
		graphqlOperation(getOtherProject(user_id, ExclusiveStartKey))
	)
})

export const getrecommendproject = () => ({
	type: GET_RECOMMEND_PROJECT,
	payload: API.graphql(graphqlOperation(getRecommendProject()))
})

export const getproject = (project_id) => ({
	type: GET_PROJECT,
	payload: API.graphql(graphqlOperation(getProject(project_id)))
})

export const getprojectoverview = (project_id) => ({
	type: GET_PROJECT,
	payload: API.graphql(graphqlOperation(getProjectOverview(project_id)))
})

export const getprojectnoti = (project_id) => ({
	type: GET_PROJECT_NOTI,
	payload: API.graphql(graphqlOperation(getProject(project_id)))
})

export const getprojecthistory = (project_id) => ({
	type: GET_PROJECT_HISTORY,
	payload: API.graphql(graphqlOperation(getProjecthistory(project_id)))
})

export const createproject = (data) => ({
	type: CREATE_PROJECT,
	payload: API.graphql(graphqlOperation(createProject, data))
})

export const updateproject = (data) => ({
	type: UPDATE_PROJECT,
	payload: API.graphql(graphqlOperation(updateProject, data))
})

export const deleteproject = (project_id) => ({
	type: DELETE_PROJECT,
	payload: API.graphql(graphqlOperation(deleteProject(project_id)))
})

export const queryprojectglobal = (
	keyword,
	value,
	ExclusiveStartKey,
	user_id
) => ({
	type: QUERY_GLOBAL_PROJECT,
	payload: API.graphql(
		graphqlOperation(queryProject(keyword, value, ExclusiveStartKey, user_id))
	)
})
export const queryprojectmy = (keyword, value, ExclusiveStartKey, user_id) => ({
	type: QUERY_MY_PROJECT,
	payload: API.graphql(
		graphqlOperation(queryProject(keyword, value, ExclusiveStartKey, user_id))
	)
})
export const putreportfile = (project_id, value) => ({
	type: PUT_REPORTFILE,
	payload: putReport(project_id, value)
})

export const getreportfile = (project_id) => ({
	type: GET_REPORTFILE,
	payload: API.graphql(graphqlOperation(getReport(project_id)))
})

export const getreportfileglobalproject = (project_id) => ({
	type: GET_REPORTFILE,
	payload: API.graphql(graphqlOperation(getReportglobalproject(project_id)))
})

export const deletereportfile = (product) => ({
	type: DELETE_REPORTFILE,
	payload: deleteReport(product)
})

export const addamountcomment = (project_id) => ({
	type: ADD_AMOUNT_COMMENT,
	payload: project_id
})

export const reduceamountcomment = (project_id) => ({
	type: REDUCE_AMOUNT_COMMENT,
	payload: project_id
})

export const clearlistglobalproject = () => ({
	type: CLEAR_LIST_GLOBAL_PROJECT
})

export const clearlistmyproject = () => ({
	type: CLEAR_LIST_MY_PROJECT
})

export const clearotherproject = () => ({
	type: CLEAR_OTHER_PROJECT
})

export const clearproject = () => ({
	type: CLEAR_PROJECT
})

export const clearreportfile = () => ({
	type: CLEAR_REPORTFILE
})

export const addlikeproject = (project_id) => ({
	type: LIKE_PROJECT,
	payload: API.graphql(graphqlOperation(addLikeProject(project_id)))
})

export const unlikeproject = (project_id) => ({
	type: UNLIKE_PROJECT,
	payload: API.graphql(graphqlOperation(unLikeProject(project_id)))
})

export const addtomyproject = (project_id) => ({
	type: ADD_TO_MY_PROJECT,
	payload: API.graphql(graphqlOperation(addToMyProject(project_id)))
})
